import { render, staticRenderFns } from "./left.vue?vue&type=template&id=4d9aae02&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=4d9aae02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9aae02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9aae02')) {
      api.createRecord('4d9aae02', component.options)
    } else {
      api.reload('4d9aae02', component.options)
    }
    module.hot.accept("./left.vue?vue&type=template&id=4d9aae02&scoped=true", function () {
      api.rerender('4d9aae02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout/left.vue"
export default component.exports